var billet = ['bb', 'yapay', 'bradesco2', 'itaushopline']
var card = ['cielo3', 'getnet']

export const billetOrCard = (method) => {
  if (method === 'yapay') {
    return ['b', 'c']
  }
  if (billet.includes(method)) {
    return ['b']
  } else if (card.includes(method)) {
    return ['c']
  }
  return null
}




// WEBPACK FOOTER //
// ./src/utils/gateway_payment_method.js